<template>
    <button class="db-btn-outline sm default danger transparent modal-btn m-0.5">
        <i class="lab lab-line-trash"></i>
        <span class="db-tooltip">{{ $t('button.delete') }}</span>
    </button>
</template>

<script>
export default {
    name: "SmDeleteComponent",
}
</script>

<style scoped>

</style>
